/** @jsxImportSource @emotion/react */
import type {CSSObject} from "@emotion/react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

export const SectionContentWrapper = styled.div(({theme}) => ({
  position: "relative",
  gridColumn: theme?.breakpoints?.isMobile ? "1/-1" : "4/14",
  width: "100%",
  marginBlock: theme?.breakpoints?.isMobile ? 30 : 50,
}));

export const AccordionItemHeader = styled.div<{styles?: CSSObject}>(
  ({theme, styles}) => ({
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "10px",
    whiteSpace: "pre-line",
    cursor: "pointer",
    fontSize: "1.25rem",
    fontWeight: 700,
    fontFamily: theme?.font?.manrope,
    paddingBlock: "16px 14px",
    ...styles,
  }),
);

export const AccordionItemContent = styled.div<{isActive?: boolean; styles?: CSSObject}>(
  ({styles}) => ({
    overflow: "hidden",
    backgroundColor: "inherit",
    ...styles,
  }),
);

export const HeaderTextWrapper = styled.div(
  (): CSSObject => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  }),
);

export const TextWrapper = styled.div({
  paddingLeft: 48,
  paddingBottom: 16,
});

export const Emoji = styled.div(() => ({
  paddingRight: 16,
}));

export const accordionItemCss = ({border}: {border?: string} = {}) => css`
  border-bottom: ${border || "1px solid #ccc"};
  position: relative;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  .szh-accordion__item {
    &-btn {
      cursor: pointer;
      display: flex;
      align-items: center;
      width: 100%;
      margin: 0;
      text-align: left;
      background-color: transparent !important;
      border: none;
    }

    &-content {
      transition: height 0.25s cubic-bezier(0, 0, 0.1, 1);
    }

    &-panel {
    }
  }

  .expand-more{
    margin-left: auto;
    transition: transform 0.25s cubic-bezier(0, 0, 0.1, 1);
  }
  .expand-more-faq{
    position: absolute;
    top: 50%;
    transform: translateY(-50%); 
    transition: transform 0.25s cubic-bezier(0, 0, 0.1, 1);
  }
  &.szh-accordion__item--expanded {
    .szh-accordion__item-btn {
      background-color: #e7e7e7;
    }
    .expand-more {
      transform: rotate(180deg);
    }
    .expand-more-faq {
      position: absolute;
      top: 50%;
      transform: translateY(-50%) rotate(45deg)
    }
  }
`;
